import Vue from "vue"
import VueAnalytics from "vue-analytics"
import router from "../../router"
import {Storage, Project} from '../Utils'

const DIM_PROJECT_TYPE = process.env.VUE_APP_GA_DIM_PROJECT_TYPE
const DIM_PROJECT_ID = process.env.VUE_APP_GA_DIM_PROJECT_ID
const DIM_PROJECT_NAME = process.env.VUE_APP_GA_DIM_PROJECT_NAME
const DIM_USER_ID = process.env.VUE_APP_GA_DIM_USER_ID

let analyticsInitialized = false

function init() {
    if (process.env.VUE_APP_GA_ID && DIM_PROJECT_TYPE && DIM_PROJECT_ID && DIM_PROJECT_NAME && DIM_USER_ID) {
        Vue.use(VueAnalytics, {
            id: process.env.VUE_APP_GA_ID,
            router,
            autoTracking: {
                pageviewTemplate (route) {
                    return buildFields(route.params.index, route.path, route.name)
                }
            }
        })
        analyticsInitialized = true
        if (Storage.getUser().id) {
            loadUserId()
        }
    }
}

function loadUserId() {
    if (analyticsInitialized) {
        Vue.$ga.set('userId', Storage.getUser().id)
    }
}

function clearUserId() {
    if (analyticsInitialized) {
        Vue.$ga.set('userId', null)
    }
}

function sendActivityEvent(label, projectIndex, routePath, routeName) {
  if(analyticsInitialized){
    Vue.$ga.event({
      eventCategory: 'Activity',
      eventAction: 'open',
      eventLabel: label,
      ...buildFields(projectIndex, routePath, routeName)
    })
  }
}

function sendVideoEvent(label, projectIndex, routePath, routeName) {
  if(analyticsInitialized){
    Vue.$ga.event({
      eventCategory: 'Video',
      eventAction: 'open',
      eventLabel: label,
      ...buildFields(projectIndex, routePath, routeName)
    })
  }
}

function buildFields(projectIndex, routePath, routeName) {
    let page = routePath
    if (projectIndex >= 0) {
        const lastIndex = page.lastIndexOf(`/${projectIndex}`)
        if (lastIndex > 0) {
            page = page.substring(0, lastIndex)
        } else {
            projectIndex = -1
        }
    }
    let fields = {
        page,
        title: routeName,
        location: window.location.href
    }
    if (projectIndex >= 0) {
        const project = Storage.getProject(projectIndex)
        if (project) {
            fields[DIM_PROJECT_TYPE] = Project.PROJECT_TYPE[project.type]
            fields[DIM_PROJECT_ID] = `${project.projectId}`
            fields[DIM_PROJECT_NAME] = project.name
        }
    }
    // support project type for start project pages
    if (routeName === 'start_project') {
        fields[DIM_PROJECT_TYPE] = Project.PROJECT_TYPE[Project.PROJECT_D4D]
    } else if (routeName === 'js_start_project') {
        fields[DIM_PROJECT_TYPE] = Project.PROJECT_TYPE[Project.PROJECT_JOB_SHADOW]
    } else if (routeName === 'be_start_project') {
        fields[DIM_PROJECT_TYPE] = Project.PROJECT_TYPE[Project.PROJECT_BE_ENTREPRENEURIAL]
    }
    const userId = Storage.getUser().id
    if (userId) {
        fields[DIM_USER_ID] = userId
    }
    return fields
}

export default {
    init,
    loadUserId,
    clearUserId,
    sendActivityEvent,
    sendVideoEvent
}
